// test2852
(2852 && 0);
